/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as moment from 'moment';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-next-report-component',
  template: `
    <span *ngIf="!model?.scheduledFor">
      <span *ngIf="condensed">Unavailable</span>
      <span *ngIf="!condensed">Next execution date is unavailable</span>
    </span>
    <span *ngIf="model?.scheduledFor">
      <span *ngIf="!scheduledForDisplay">
        <span *ngIf="condensed">Expired</span>
        <span *ngIf="!condensed">This report schedule has expired and will not execute any more reports.</span>
      </span>
      <span *ngIf="scheduledForDisplay">
        {{ scheduledForDisplay | localeDate:'fullDate' }} {{ scheduledForDisplay | localeDate:'shortTime' }}
      </span>
    </span>
  `
})
export class NextReportComponent implements OnChanges {
  @Input() model: {scheduledFor?: string};
  @Input() condensed = false;

  scheduledForDisplay: string | null = null;

  ngOnChanges(): void {
    if (!this.model?.scheduledFor) {
      this.scheduledForDisplay = null;
      return;
    }
    const scheduledDate = new Date(this.model.scheduledFor);
    this.scheduledForDisplay = moment().add(100, 'y').isBefore(scheduledDate) ? null : this.model.scheduledFor;
  }
}
